import { MainPageLayoutProps } from "@components/page-layout/main-page-layout";
import { Box } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import { withEllipsis } from "@styles/common-styles";

type Props = Pick<MainPageLayoutProps, "centerComponent">;

/** Content for the center of layout header */
export function HeaderLayoutCenter({
  centerComponent,
}: Props): JSX.Element | null {
  if (!centerComponent) {
    return null;
  }

  return (
    <Grid2
      alignItems="center"
      sx={{
        ...withEllipsis,
      }}
    >
      <Box
        component="div"
        sx={{
          px: "10px",
          ...withEllipsis,
        }}
      >
        {centerComponent}
      </Box>
    </Grid2>
  );
}
